document.addEventListener('DOMContentLoaded', function () {
    const ghost = document.querySelector("form-contact-ghost");
    const panel = document.querySelector("form-contact-contain");
    if(ghost && panel){
        const observer = new ResizeObserver(entries => {
            for(let entry of entries){
                ghost.style.height = `${entry.contentRect.height}px`;
            }
        });
        observer.observe(panel);
    }
});